// extracted by mini-css-extract-plugin
export default {"grow":"otp-form-field_grow__JxQE5","otpFormField":"otp-form-field_otpFormField__lqdyr","error":"otp-form-field_error__FgdyS","hidden":"otp-form-field_hidden__QkzUR"};